'use strict';

/**
 * ScrollToTop
 *
 * @author Zorica Janjic <zorica.janjic@namics.com>
 */
T.Module.ScrollToTop = T.createModule({

	_selectors: {
		// ..
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		// Component Event Binding
		this.$ctx.on('click', this.$onClick.bind(this));

		resolve();
	},
	$onClick: function $onClick() {
		$('html,body').animate({ scrollTop: 0 }, 'slow');
		return false;
	}
});